var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmoothBlurBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1436,
    height: 604,
    viewBox: "0 0 1436 604",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_247_3)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1436,
    height: 604,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.543 108.483C262.907 84.838 228.002 80.678 0 51V425H1436V163.085C1331.68 148.478 1260.23 162.239 1165.3 146.805C1050.2 128.092 965.564 133.385 893.769 125.483C699.22 104.072 601.123 127.918 448.543 108.483Z",
    fill: "#E2E2FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.615 152.398C257.777 129.98 228.002 94.8821 0 51V604H1436V290.861C1346.69 294.014 1271.76 272.646 1163.23 252.73C1049.91 235.431 939.016 245.703 872.627 224.398C733.629 179.794 655.823 176.253 450.615 152.398Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_bf_247_3)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 520,
    cy: 188,
    rx: 394,
    ry: 214,
    fill: "#C4C4C4",
    fillOpacity: 0.01
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_bf_247_3)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1196.5,
    cy: 228,
    rx: 161.5,
    ry: 88,
    fill: "#C4C4C4",
    fillOpacity: 0.01
  })), /*#__PURE__*/React.createElement("path", {
    d: "M416.204 188.447C223.334 172.19 237.256 142.164 11 103.874V518H1436V261.867C1277.77 266.779 1098.58 275.778 898.334 234.172C739.034 201.073 636.985 207.056 416.204 188.447Z",
    fill: "#FDC6C7"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_247_3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M416.204 212.238C223.334 195.982 237.256 165.956 11 127.666V518H1436V287.889C1299.84 280.64 1102.37 279.684 874.886 265.584C701.176 254.817 636.985 230.847 416.204 212.238Z",
    fill: "#FEE3E3"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M681.612 179.883C526.382 147.576 461.089 158.104 328.583 173.825V425.217H1436V278.824C1272.77 262.526 1236.72 248.218 1021.52 240.748C801.316 233.104 749.064 193.921 681.612 179.883Z",
    fill: "#E1C9FB"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_247_3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M681.612 179.883C526.382 147.576 461.089 158.104 328.583 173.825V425.217H1436V286.901C1274.07 277.718 1238.68 277.389 1021.52 259.209C804.379 241.031 749.064 193.921 681.612 179.883Z",
    fill: "#EBD8FF"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_bf_247_3)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 690.5,
    cy: 292.5,
    rx: 204.5,
    ry: 111.5,
    fill: "#C4C4C4",
    fillOpacity: 0.01
  })), /*#__PURE__*/React.createElement("path", {
    d: "M969.508 270.892C712.984 255.427 656.666 227.861 542.858 195.748C448.482 169.119 402.887 141.104 350.699 126.951C238.808 97.0403 80.7729 100.575 0 82.24V425.217H1436V310.987C1315.77 317.345 1249.32 297.009 1171.21 284.738C1093.76 274.479 1014.17 273.584 969.508 270.892Z",
    fill: "#CFF2FF"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_f_247_3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1000.22 304.353C740.047 287.598 638.933 274.604 542.858 253.44C480.453 239.693 437.731 207.908 350.699 184.643C238.808 154.732 80.7729 158.266 0 139.932V425.217H1436V330.314C1197.77 311.708 1118.92 311.997 1000.22 304.353Z",
    fill: "#D8BAFF"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M298.061 276.661C154.307 245.955 143.434 206.421 0 173.826V425.217H1436V382.092C1235.1 360.116 1035.14 368.814 760.284 326.853C572.378 298.165 483.731 316.32 298.061 276.661Z",
    fill: "#FFF7F7"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_f_247_3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M221.37 313.439C84.5031 279.135 143.434 293.68 0 261.084V450.601H1436V398.246C1235.01 368.561 925.374 389.627 628.872 371.131C412.231 357.616 367.849 350.153 221.37 313.439Z",
    fill: "#FEE3E3"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_bf_247_3)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 64,
    cy: 316.5,
    rx: 391,
    ry: 212.5,
    fill: "#C4C4C4",
    fillOpacity: 0.01
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bf_247_3",
    x: 86,
    y: -66,
    width: 868,
    height: 508,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 16
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_247_3"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_247_3",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20,
    result: "effect2_foregroundBlur_247_3"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_bf_247_3",
    x: 995,
    y: 100,
    width: 403,
    height: 256,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 16
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_247_3"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_247_3",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20,
    result: "effect2_foregroundBlur_247_3"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_247_3",
    x: -20.9746,
    y: 95.6915,
    width: 1488.95,
    height: 454.283,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15.9873,
    result: "effect1_foregroundBlur_247_3"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_247_3",
    x: 316.285,
    y: 146.507,
    width: 1132.01,
    height: 291.007,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.14896,
    result: "effect1_foregroundBlur_247_3"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_bf_247_3",
    x: 462,
    y: 157,
    width: 457,
    height: 271,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_247_3"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_247_3",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12,
    result: "effect2_foregroundBlur_247_3"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_247_3",
    x: -36.8938,
    y: 103.038,
    width: 1509.79,
    height: 359.073,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 18.4469,
    result: "effect1_foregroundBlur_247_3"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f_247_3",
    x: -31.9746,
    y: 229.109,
    width: 1499.95,
    height: 253.466,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15.9873,
    result: "effect1_foregroundBlur_247_3"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_bf_247_3",
    x: -367,
    y: 64,
    width: 862,
    height: 505,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 16
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_247_3"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_247_3",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20,
    result: "effect2_foregroundBlur_247_3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_247_3"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1436,
    height: 604,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmoothBlurBackground);
export default __webpack_public_path__ + "static/media/smooth_blur_background.21bc4f6a2e918f404e49e09b88f55111.svg";
export { ForwardRef as ReactComponent };